import { Success3d } from '../assets';
import { Heading } from './heading';
import { Typography } from './typography';

interface SuccessContentProps {
  title: string;
  text: string;
}

export const SuccessContent = ({ title, text }: SuccessContentProps) => {
  return (
    <div className="flex flex-col items-center px-5 pt-10">
      <img className="mb-10 h-[97px] w-[120px]" src={Success3d} />

      <Heading className="mb-3" variant="m" tag="span">
        {title}
      </Heading>

      <Typography className="mb-10 text-center" variant="16-r" color="base-300">
        {text}
      </Typography>
    </div>
  );
};
